import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectSetupReducer } from '../reducers';

export const selectProjectSetupFeature = createFeatureSelector<ProjectSetupReducer.ProjectSetupState>(ProjectSetupReducer.featureName);

export const selectProjectSetup = createSelector(selectProjectSetupFeature, (state: ProjectSetupReducer.ProjectSetupState) => state.item);
